import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Mail, Youtube, Music } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const { darkMode } = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`footer ${darkMode ? 'dark' : ''}`}>
      <div className="footer-container">
        <div className="footer-brand">
          <div className="footer-logo">
            <Music size={24} />
            <span>Falphin</span>
          </div>
          <p className="footer-tagline">
            Empowering artists with transparent, fair music distribution.
          </p>
          <div className="social-links">
            <a href="https://youtube.com/@falphin?si=EKY2nRIRw_WOs-Rf" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="social-icon">
              <Youtube size={20} />
            </a>
            <a href="https://discord.gg/b7yrrG8w" target="_blank" rel="noopener noreferrer" aria-label="Discord" className="social-icon">
              <img 
                src={`${process.env.PUBLIC_URL}/images/social/Discord-logo.png`} 
                alt="Discord" 
                className="discord-icon"
                width="20"
                height="20"
              />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <h3>Company</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/ambassadors">Ambassadors</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/press">Press</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Resources</h3>
            <ul>
              <li><Link to="/help">Help Center</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/royalty-advances" className="highlight-link">Royalty Advances <span className="highlight-badge">New</span></Link></li>
              <li><Link to="/status">Status</Link></li>
              <li><Link to="/api">API</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Legal</h3>
            <ul>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/cookies">Cookie Policy</Link></li>
              <li><Link to="/copyright">Copyright</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Contact</h3>
            <ul>
              <li>
                <a href="mailto:support@falphin.com">
                  <Mail size={16} className="contact-icon" />
                  support@falphin.com
                </a>
              </li>
              <li>71-75 Shelton Street</li>
              <li>London</li>
              <li>WC2H 9JQ, United Kingdom</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {currentYear} Falphin. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/terms">Terms</Link>
            <span className="divider">•</span>
            <Link to="/privacy">Privacy</Link>
            <span className="divider">•</span>
            <Link to="/cookies">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
